module.exports = __webpack_public_path__ + "img/img-intro2.6baf253b.jpg";